import { UserProfile } from '@totem/types/user';

export const isInternalEmailAddress = (emailAddress: string) => {
  if (emailAddress !== null) {
    return (
      emailAddress.toLowerCase().endsWith('@intelligentbuildings.com') ||
      emailAddress.toLowerCase().startsWith('shannon.smith')
    );
  }
  return false;
};

export const isIBUser = (userProfile: UserProfile) => {
  if (userProfile !== null) {
    return isInternalEmailAddress(userProfile.email);
  }
  return false;
};
